/* ==========================================================================
   NUCHE — storefront behaviour
   Gallery, bundle ladder, variant selection, accordions, review sorting.
   ========================================================================== */

(function () {
  "use strict";

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- sticky header shadow ---------- */

  var header = $(".site-header");
  if (header) {
    var onScroll = function () {
      header.classList.toggle("is-stuck", window.scrollY > 8);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---------- mobile menu ---------- */

  var menuToggle = $(".menu-toggle");
  if (menuToggle) {
    var nav = $(".nav");

    var setMenu = function (open) {
      if (!nav) return;
      nav.classList.toggle("nav--open", open);
      menuToggle.setAttribute("aria-expanded", open ? "true" : "false");
    };

    menuToggle.addEventListener("click", function () {
      setMenu(!(nav && nav.classList.contains("nav--open")));
    });

    if (nav) {
      /* Tapping a link should dismiss the panel, and so should Escape or a tap
         anywhere else — otherwise it stays open over the page. */
      nav.addEventListener("click", function (e) {
        if (e.target.closest("a")) setMenu(false);
      });

      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") setMenu(false);
      });

      document.addEventListener("click", function (e) {
        if (!nav.classList.contains("nav--open")) return;
        if (e.target.closest(".nav") || e.target.closest(".menu-toggle")) return;
        setMenu(false);
      });
    }
  }

  /* ---------- accordions ---------- */

  $$(".accordion__trigger").forEach(function (trigger) {
    var panel = trigger.nextElementSibling;
    if (!panel) return;
    var setOpen = function (open) {
      trigger.setAttribute("aria-expanded", open ? "true" : "false");
      panel.style.maxHeight = open ? panel.scrollHeight + "px" : "0px";
    };
    setOpen(trigger.getAttribute("aria-expanded") === "true");
    trigger.addEventListener("click", function () {
      setOpen(trigger.getAttribute("aria-expanded") !== "true");
    });
    window.addEventListener("resize", function () {
      if (trigger.getAttribute("aria-expanded") === "true") {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  });

  /* ---------- product gallery ---------- */

  var galleryMain = $(".gallery__main .gallery__still") || $(".gallery__main img");
  var galleryFrame = $(".gallery__main");
  var galleryVideo = $(".gallery__video", galleryFrame);
  var galleryVideoEl = galleryVideo ? $("video", galleryVideo) : null;

  function showVideo() {
    if (galleryVideo) galleryVideo.classList.add("is-active");
    if (galleryMain) galleryMain.classList.remove("is-active");
    if (galleryVideoEl) { try { galleryVideoEl.currentTime = 0; galleryVideoEl.play(); } catch (e) {} }
    if (galleryFrame && galleryVideo) galleryFrame.style.aspectRatio = galleryVideo.dataset.ratio;
  }
  function showStill() {
    if (galleryVideo) galleryVideo.classList.remove("is-active");
    if (galleryVideoEl) { try { galleryVideoEl.pause(); } catch (e) {} }
    if (galleryMain) galleryMain.classList.add("is-active");
  }

  $$(".thumb").forEach(function (thumb) {
    thumb.addEventListener("click", function () {
      var img = $("img", thumb);
      if (!img) return;
      $$(".thumb").forEach(function (t) { t.setAttribute("aria-selected", "false"); });
      thumb.setAttribute("aria-selected", "true");

      if (thumb.dataset.video) { showVideo(); return; }

      showStill();
      if (!galleryMain) return;
      galleryMain.src = img.dataset.full || img.src;
      galleryMain.alt = img.alt;
      // Resize the frame to the incoming image so it neither crops nor letterboxes.
      if (galleryFrame && img.getAttribute("width") && img.getAttribute("height")) {
        galleryFrame.style.aspectRatio = img.getAttribute("width") + " / " + img.getAttribute("height");
      }
    });
  });

  /* ---------- variant + bundle selection ---------- */

  /* tier starts unset so pages with a single order option (the Butterfly Pillow has no
     bundle ladder) fall back to the card that is actually on the page. */
  var state = { traction: "Curve S", colour: "Cloud Blue", tier: null };

  /* ?pack=1 or ?pack=2 from an advertorial CTA preselects the bundle tier, so a
     reader who clicked "get the 2-pack" lands on the 2-pack already chosen. */
  try {
    var packParam = new URLSearchParams(location.search).get("pack");
    if (packParam === "1" || packParam === "2") state.tier = packParam;
  } catch (e) {}

  var TIER_LABEL = { "1": "1 Pillow", "2": "2 Pillows" };

  function money(n) { return "$" + n.toFixed(2).replace(/\.00$/, ""); }

  /* Resolve the selected bundle card. If state.tier names a tier this page does not
     have (or is unset), use the first card present so the label never falls back to a
     tier name the visitor cannot see. */
  function tierCard() {
    var card = null;
    if (state.tier) card = $('.bundle__card[data-tier="' + state.tier + '"]');
    if (!card) card = $(".bundle__card");
    return card;
  }

  function tierPrice() {
    var card = tierCard();
    return card ? Number(card.dataset.price) : 0;
  }

  function render() {
    var price = tierPrice();
    var label = $("#atc-label");
    if (label) {
      var chosen = tierCard();
      var tierName = (chosen && chosen.getAttribute("data-label")) || TIER_LABEL[state.tier];
      label.textContent = price > 0
        ? "Add to cart — " + (tierName || "") + " · " + money(price)
        : "Add to cart";
    }
    var summary = $("#selection-summary");
    if (summary) {
      summary.textContent = state.traction + " (" + (state.traction === "Curve Z" ? "26°" : "18°") + ") · " + state.colour;
    }
    var ap = $("#afterpay-amount");
    if (ap) ap.textContent = money(Math.round((price / 4) * 100) / 100);

    var variantSku = $("#variant-sku");
    if (variantSku) {
      variantSku.textContent = "NUC-" + (state.traction === "Curve Z" ? "ARZ" : "ARS") + "-" +
        (state.colour === "Dusk Navy" ? "CN" : "CG");
    }
  }

  $$(".bundle__card").forEach(function (card) {
    card.addEventListener("click", function () {
      $$(".bundle__card").forEach(function (c) { c.setAttribute("aria-checked", "false"); });
      card.setAttribute("aria-checked", "true");
      state.tier = card.dataset.tier;
      render();
    });
  });

  $$(".opt[data-group='traction']").forEach(function (opt) {
    opt.addEventListener("click", function () {
      $$(".opt[data-group='traction']").forEach(function (o) { o.setAttribute("aria-checked", "false"); });
      opt.setAttribute("aria-checked", "true");
      state.traction = opt.dataset.value;
      var target = $('.thumb[data-variant="' + state.traction + '"]');
      if (target) target.click();
      render();
    });
  });

  $$(".swatch[data-group='colour']").forEach(function (sw) {
    sw.addEventListener("click", function () {
      $$(".swatch[data-group='colour']").forEach(function (s) { s.setAttribute("aria-checked", "false"); });
      sw.setAttribute("aria-checked", "true");
      state.colour = sw.dataset.value;
      var target = $('.thumb[data-colour="' + state.colour + '"]');
      if (target) target.click();
      render();
    });
  });

  /* ---------- add to cart ---------- */

  var atc = $("#add-to-cart");
  if (atc) {
    atc.addEventListener("click", function () {
      var cartCount = $(".cart-count");
      if (cartCount) cartCount.textContent = String(Number(cartCount.textContent || "0") + Number(state.tier));
      atc.textContent = "Added ✓";
      setTimeout(function () { render(); }, 1400);
    });
  }

  /* ---------- review sorting ---------- */

  var grid = $("#review-grid");
  if (grid) {
    var original = $$(".review", grid);
    var score = function (el) { return Number(el.dataset.rating || 0); };
    var date = function (el) { return Number(el.dataset.order || 0); };

    $$(".review-sort button").forEach(function (btn) {
      btn.addEventListener("click", function () {
        $$(".review-sort button").forEach(function (b) { b.setAttribute("aria-pressed", "false"); });
        btn.setAttribute("aria-pressed", "true");
        var mode = btn.dataset.sort;
        var list = original.slice();
        if (mode === "highest") list.sort(function (a, b) { return score(b) - score(a) || date(b) - date(a); });
        else if (mode === "lowest") list.sort(function (a, b) { return score(a) - score(b) || date(b) - date(a); });
        else list.sort(function (a, b) { return date(b) - date(a); });
        list.forEach(function (el) { grid.appendChild(el); });
      });
    });
  }

  /* ---------- scroll to reviews ---------- */

  $$("[data-scroll-to]").forEach(function (el) {
    el.addEventListener("click", function (e) {
      var target = $(el.dataset.scrollTo);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  });

  render();
})();
  /* ---------- review wall show more ---------- */
  (function () {
    var grid = document.getElementById("review-grid");
    var btn = document.getElementById("reviews-toggle");
    if (!grid || !btn) return;
    btn.addEventListener("click", function () {
      var collapsed = grid.classList.toggle("is-collapsed");
      btn.setAttribute("aria-expanded", collapsed ? "false" : "true");
      btn.textContent = collapsed
        ? "Show all " + btn.dataset.total + " reviews"
        : "Show fewer reviews";
      if (collapsed) grid.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  })();
/* ==========================================================================
   NUCHE — roaming sticky add-to-cart
   Appears once the buy column has scrolled past, and stays in step with the
   selected bundle tier.
   ========================================================================== */
(function () {
  var bar = document.getElementById("sticky-atc");
  if (!bar) return;

  var anchor = document.querySelector(".buy-actions");
  var priceOut = document.getElementById("sticky-price");
  var variantIn = bar.querySelector("[data-variant-id]");
  var hidden = true;

  function setVisible(next) {
    if (next === !hidden) return;
    hidden = !next;
    bar.classList.toggle("is-visible", next);
    bar.setAttribute("aria-hidden", next ? "false" : "true");
  }

  function onScroll() {
    if (!anchor) return setVisible(window.scrollY > 420);

    var rect = anchor.getBoundingClientRect();
    var past = rect.bottom < 0;                     // buy column scrolled above
    var atEnd = window.innerHeight + window.scrollY >= document.body.offsetHeight - 120;
    setVisible(past && !atEnd);
  }

  /* Keep the bar in step with the chosen bundle. */
  function syncFromTier(card) {
    if (!card) return;
    var price = card.getAttribute("data-price");
    var variant = card.getAttribute("data-variant-id");
    if (priceOut) priceOut.textContent = "$" + Number(price).toLocaleString("en-AU");
    if (variant && variantIn) variantIn.value = variant;
  }

  var bundle = document.querySelector(".bundle");
  if (bundle) {
    bundle.addEventListener("click", function (e) {
      var card = e.target.closest(".bundle__card");
      if (card) syncFromTier(card);
    });
    syncFromTier(bundle.querySelector('.bundle__card[aria-checked="true"]'));
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll, { passive: true });
  onScroll();
})();
/* ==========================================================================
   NUCHE — instant navigation
   Warm same-origin pages on pointer/focus intent so the next click is served
   from the browser cache. Cheap, and it makes navigation feel immediate.
   ========================================================================== */
(function () {
  var conn = navigator.connection || {};
  if (conn.saveData) return;

  var seen = Object.create(null);

  function warm(href) {
    if (!href || seen[href]) return;
    seen[href] = 1;
    var link = document.createElement("link");
    link.rel = "prefetch";
    link.as = "document";
    link.href = href;
    document.head.appendChild(link);
  }

  function consider(e) {
    var a = e.target && e.target.closest ? e.target.closest("a[href]") : null;
    if (!a) return;
    var href = a.getAttribute("href");
    if (!href || href.charAt(0) === "#") return;
    var url;
    try { url = new URL(a.href, location.href); } catch (err) { return; }
    if (url.origin !== location.origin) return;
    if (url.pathname === location.pathname && url.search === location.search) return;
    warm(url.pathname + url.search);
  }

  document.addEventListener("pointerover", consider, { passive: true });
  document.addEventListener("touchstart", consider, { passive: true });
  document.addEventListener("focusin", consider);
})();

/* ==========================================================================
   Cart page - quantity changes and removals without a page reload.

   Posts to Shopify's /cart/change.js and re-renders the affected numbers from
   the returned cart. If the request fails, or JavaScript is off entirely, the
   plain form posts to /cart and the server renders the same result.
   ========================================================================== */
(function () {
  var form = document.getElementById("cart-form");
  if (!form) return;

  var lines = form.querySelector(".cart-lines");
  var subtotalEl = form.querySelector("[data-subtotal]");

  function money(cents) {
    var value = (cents / 100).toFixed(2);
    return "$" + value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function changeCart(line, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) {
      if (!r.ok) throw new Error("cart change failed");
      return r.json();
    });
  }

  function paint(cart) {
    // Quantities can shift lines around, so match by variant id.
    var byVariant = {};
    cart.items.forEach(function (item) {
      byVariant[item.variant_id] = item;
    });

    var empty = false;
    lines.querySelectorAll(".cart-line").forEach(function (row) {
      var input = row.querySelector("input[data-line]");
      var id = row.getAttribute("data-variant-id");
      var item = byVariant[id];

      if (!item) {
        row.remove();
        empty = true;
        return;
      }
      input.value = item.quantity;
      var price = row.querySelector("[data-line-price]");
      if (price) price.textContent = money(item.final_line_price);
    });

    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);

    if (cart.item_count === 0 || empty) {
      window.location.reload();
      return;
    }

    var note = form.querySelector("[data-ship-note]");
    if (note) {
      note.textContent = "Free tracked shipping on every order \u2014 Australia and New Zealand.";
    }
  }

  function fail() {
    window.location.reload();
  }

  form.addEventListener("change", function (e) {
    var input = e.target.closest("input[data-line]");
    if (!input) return;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) {
      input.value = 1;
      qty = 1;
    }
    changeCart(parseInt(input.getAttribute("data-line"), 10), qty)
      .then(paint)
      .catch(fail);
  });

  form.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-remove]");
    if (!btn) return;
    e.preventDefault();
    var row = btn.closest(".cart-line");
    var input = row && row.querySelector("input[data-line]");
    if (!input) return;
    changeCart(parseInt(input.getAttribute("data-line"), 10), 0)
      .then(paint)
      .catch(fail);
  });
})();
/* ---------------------------------------------------------------------------
   Gallery navigation for every product gallery on the site: the product page and the
   homepage showcase. Arrows, swipe and keyboard simply move the selection by clicking
   the neighbouring thumbnail, so the existing thumbnail handler stays the single code
   path for swapping the image, the video and the frame aspect ratio.
   Self-contained on purpose — this sits outside theme.js's main IIFE.
   --------------------------------------------------------------------------- */
(function () {
  var galleries = Array.prototype.slice.call(document.querySelectorAll(".gallery"));

  galleries.forEach(function (gallery) {
    if (gallery.dataset.navReady) return;
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll(".thumb"));
    if (thumbs.length < 2) return;
    var frame = gallery.querySelector(".gallery__main");
    if (!frame) return;
    gallery.dataset.navReady = "1";

    function current() {
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].getAttribute("aria-selected") === "true") return i;
      }
      return 0;
    }
    function go(i) {
      var n = thumbs.length;
      thumbs[((i % n) + n) % n].click();
    }

    var prev = gallery.querySelector(".gallery__arrow--prev");
    var next = gallery.querySelector(".gallery__arrow--next");
    if (prev) prev.addEventListener("click", function () { go(current() - 1); });
    if (next) next.addEventListener("click", function () { go(current() + 1); });

    /* Touch swipe. Horizontal only, past a threshold, so a vertical page scroll that
       begins on the image is never hijacked. */
    var x0 = null, y0 = null;
    frame.addEventListener("touchstart", function (e) {
      if (e.touches.length !== 1) { x0 = null; return; }
      x0 = e.touches[0].clientX;
      y0 = e.touches[0].clientY;
    }, { passive: true });
    frame.addEventListener("touchend", function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - x0, dy = t.clientY - y0;
      x0 = null; y0 = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      go(dx < 0 ? current() + 1 : current() - 1);
    }, { passive: true });

    gallery.setAttribute("tabindex", "0");
    gallery.addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft") { e.preventDefault(); go(current() - 1); }
      if (e.key === "ArrowRight") { e.preventDefault(); go(current() + 1); }
    });

  });
})();
